import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';


export const shopAdminApi = createApi({
    reducerPath: "shop-admin",
    baseQuery: createCustomFetchBaseQuery(),
    tagTypes: ["ShopAdmin"],
    endpoints: (builder) => ({
        getShopAdmins: builder.query({
            query: ({ status, pageno, limit, search ,disablePagination}) => {
                let url = `admin/shop-admins?pageno=${pageno + 1}`;

                if (limit) {
                    url += `&limit=${limit}`
                }
                if (search) {
                    url += `&search=${search}`;
                }
                if (status) {
                    url += `&status=${status}`;
                }
                if(disablePagination){
                    url += `&disablePagination=${disablePagination}`;
                }
                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["ShopAdmin"],
        }),
        createShopAdmin: builder.mutation({
            query: (data) => ({
                url: `/admin/shop-admin`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["ShopAdmin"],
        }),
        getShopAdminProfile: builder.query({
             query: ({ id, build_type, pageno,limit }) => {
                let url = `/admin/shop-admin/${id}?pageno=${pageno}`
                if(build_type){
                    url += `&build_type=${build_type}`
                }
                if(limit){
                    url += `&limit=${limit}`
                }

                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["ShopAdmin"],
        }),
        updateShopAdmin: builder.mutation({
            query: ({ id, data }) => ({
                url: `/admin/shop-admin/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["ShopAdmin"],
        }),
        updateShopAdminStatus: builder.mutation({
            query: ({ id }) => ({
                url: `/admin/shop-admin/status/${id}`,
                method: "PUT",
            }),
            invalidatesTags: ["ShopAdmin"],
        }),
        deleteShopAdmin: builder.mutation({
            query: (id) => ({
                url: `/admin/shop-admin/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["ShopAdmin"],
        })
    }),
});

export const { useGetShopAdminsQuery, useCreateShopAdminMutation, useGetShopAdminProfileQuery, useUpdateShopAdminMutation, useUpdateShopAdminStatusMutation , useDeleteShopAdminMutation} = shopAdminApi;